

























import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { ChapterItem } from '@/app/shared/models/reports/ChapterItem';
import { ChapterItemType } from '@/app/shared/enums/chapter-item-type.enum';
import { ChapterItemMode } from '@/app/shared/types/chapter-item-mode.type';
import ChapterItemComponent from '@/app/reports/components/ChapterItem/ChapterItem.vue';
import ImpactTable from '@/app/shared/components/ImpactTable.vue';
import _debounce from 'lodash.debounce';
import { UpdateChapterItemPayload } from '@/app/shared/store/modules/reports.store-module';
import { GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE } from '@/app/shared/store/modules/presentations.constants';
import { SingleImpact } from '@/app/shared/models/reports/SingleImpact';

const ReportsStore = namespace('Reports');

@Component({
  components: { ChapterItemComponent, ImpactTable },
})
export default class SingleImpactHeaderChapterItem extends Vue {
  @Prop() singleImpact: SingleImpact;
  @Prop() item: ChapterItem;
  @Prop({ default: false, type: Boolean }) isEditModeAllowed: boolean;
  @Prop({ default: false, type: Boolean }) singleImpactView: boolean;

  ChapterItemType: ChapterItemType;

  @ReportsStore.Action
  public updateChapterItem!: (payload: UpdateChapterItemPayload) => Promise<any>;

  @ReportsStore.Action
  public lockChapterItem!: (uuid: string) => Promise<any>;

  @ReportsStore.Action
  public unlockChapterItem!: (uuid: string) => Promise<any>;

  title: string = null;
  @Emit('switchMode')
  switchMode(_newMode: ChapterItemMode) {
    // just emiting event
  }

  get alternativesRow(): string {
    return this.singleImpact.unit.grouped_tags.alternatives.children
      .filter((el) => el.checked)
      .map((el) => el.title)
      .join(' | ');
  }

  get phasesRow(): string {
    return this.singleImpact.unit.grouped_tags['development-phases'].children
      .filter((el) => el.checked)
      .map((el) => el.title)
      .join(' | ');
  }

  get signCol(): string {
    return this.singleImpact.unit.grouped_tags.sign.children
      .filter((el) => el.checked)
      .map((el) => el.title)
      .join(' | ');
  }

  get typeCol(): string {
    return this.singleImpact.unit.grouped_tags.type.children
      .filter((el) => el.checked)
      .map((el) => el.title)
      .join(' | ');
  }

  get classCol(): string {
    return this.singleImpact.unit.grouped_tags['method-approach'].children
      .filter((el) => el.checked)
      .map((el) => el.title)
      .join(' | ');
  }

  async updateImpactTable(table: HTMLElement): Promise<any> {
    const html = `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              ${GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE}
              * {
                font-family: 'Graphik', Avenir, Helvetica, Arial, sans-serif;
              }
            </style>
          </head>
          <body>
            ${table.innerHTML}
          </body>
        </html>
        `;

    const additionalProperties = [
      {
        name: 'unit_id',
        value: this.singleImpact.id,
      },
    ];

    if (this.item.html != html) {
      await this.lockChapterItem(this.item.uuid);
      await this.updateChapterItem({
        uuid: this.item.uuid,
        type: ChapterItemType.SINGLE_IMPACT_HEADER,
        propertyName: 'html',
        propertyValue: html,
        additionalProperties,
      });
      await this.unlockChapterItem(this.item.uuid);
    }
  }
}
